const styles = {
  container: {
    listStyle: 'none',
    padding: 0,
    margin: '0 8% 0 0',
    display: 'flex'
  },
  counter: {
    margin: '0 14px',
    textAlign: 'center',
    '& > strong': {
      display: 'block',
      fontSize: '22px'
    }
  }
}

export default styles
